import authService from './authService';

const AGENT_PARENT_API_URL = process.env.REACT_APP_AGENT_PARENT_API_URL || 'https://your-agent-parent-api-url.execute-api.us-east-1.amazonaws.com/prod';

const externalMcpServersService = {
  /**
   * Get all external MCP servers for the current user
   */
  async getExternalMcpServers() {
    try {
      // API Gateway Cognito authorizers use ID tokens, not access tokens
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/external-mcp-servers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch external MCP servers');
      }

      const data = await response.json();
      return data.servers || [];
    } catch (error) {
      console.error('Error fetching external MCP servers:', error);
      throw error;
    }
  },

  /**
   * Add or update an external MCP server
   */
  async putExternalMcpServer(serverName, mcpUrl, discoveryUrl, allowedClientIds) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/external-mcp-servers`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
        body: JSON.stringify({
          serverName,
          mcpUrl,
          discoveryUrl,
          allowedClientIds,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to save external MCP server');
      }

      return await response.json();
    } catch (error) {
      console.error('Error saving external MCP server:', error);
      throw error;
    }
  },

  /**
   * Delete an external MCP server
   */
  async deleteExternalMcpServer(serverName) {
    try {
      const idToken = await authService.getIdToken();
      
      if (!idToken) {
        throw new Error('No ID token available');
      }

      const response = await fetch(`${AGENT_PARENT_API_URL}/external-mcp-servers?serverName=${encodeURIComponent(serverName)}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to delete external MCP server');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting external MCP server:', error);
      throw error;
    }
  },
};

export default externalMcpServersService;
